module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.occurrence) ? _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "is-parent"
  }, [_c('div', {
    staticClass: "is-half column"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Ticket "), (parseInt(_vm.occurrence.type) == 2) ? _c('span', [_vm._v("Internal")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth",
    staticStyle: {
      "box-shadow": "0 2px 3px #A71C20, 0 0 0 1px #A71C20"
    }
  }, [_c('header', {
    staticClass: "card-header is-primary",
    staticStyle: {
      "box-shadow": "0 1px 0px #A71C20, 0 0 0 0px #A71C20",
      "background-color": "#A71C20"
    }
  }, [_c('p', {
    staticClass: "card-header-title is-primary",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("#" + _vm._s(_vm.occurrence.id) + " - " + _vm._s(_vm.occurrence.subject))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('p', [_c('b', [_vm._v("Department:")]), _vm._v(" " + _vm._s(_vm.parseDepartament(_vm.occurrence.departament))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.parseStatus(_vm.occurrence.status))), _c('br')])]), _vm._v(" "), _c('article', {
    staticClass: "media"
  }, [_c('pre', [_vm._v(_vm._s(_vm.occurrence.occurrence))])]), _vm._v(" "), (_vm.occurrence.files.length > 0) ? _c('article', {
    staticClass: "media"
  }, [(_vm.showFiles == false) ? [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.loadFiles
    }
  }, [_vm._m(0), _c('span', [_vm._v("Show Files (" + _vm._s(_vm.occurrence.files.length) + ")")])])] : [_c('div', {
    staticClass: "columns is-multiline"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.occurrence_files), function(file) {
    return [_c('div', {
      staticClass: "column is-12",
      staticStyle: {
        "text-align": "center"
      }
    }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": file['url'],
        "alt": "",
        "width": "90%"
      }
    })])] : [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o fa-4",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                  " + _vm._s(file['name']) + "\n                                ")])]], 2), _vm._v(" "), _c('div', {
      staticClass: "column is-12"
    }, [_c('article', {
      staticClass: "media"
    })])]
  })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "is-pulled-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.occurrence.user.name) + " (" + _vm._s(_vm.occurrence.user.agency !== null ? _vm.occurrence.user.agency.name : (_vm.occurrence.user.base !== null ? _vm.occurrence.user.base.name : 'Sistema')) + ")")]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(_vm.occurrence.created_at))])])])])])])]), _vm._v(" "), _vm._l((_vm.occurrence.replies), function(reply, index) {
    return [(parseInt(reply.type) == 2) ? [(parseInt(_vm.$store.state.config.user.level) < 4) ? [_c('div', {
      staticClass: "column is-12"
    }, [_c('div', {
      staticClass: "card is-fullwidth tip"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('pre', [_vm._v(_vm._s(reply.reply))]), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }) : _vm._e(), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [(reply.showFiles == false) ? [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.loadFilesReply(reply, index)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Show attachments (" + _vm._s(reply.files.length) + ")")])])] : [_c('div', {
      staticClass: "columns is-multiline"
    }, [_vm._m(4, true), _vm._v(" "), _vm._l((reply.files), function(file) {
      return [_c('div', {
        staticClass: "column is-12",
        staticStyle: {
          "text-align": "center"
        }
      }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file['url'],
          "alt": "",
          "width": "90%"
        }
      })])] : [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o fa-4",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                                          " + _vm._s(file['name']) + "\n                                        ")])]], 2), _vm._v(" "), _c('div', {
        staticClass: "column is-12"
      }, [_c('article', {
        staticClass: "media"
      })])]
    })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(reply.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])])])])])])] : _vm._e()] : [_c('div', {
      staticClass: "column is-12"
    }, [_c('div', {
      staticClass: "card is-fullwidth"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('pre', [_vm._v(_vm._s(reply.reply))]), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }) : _vm._e(), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [(reply.showFiles == false) ? [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.loadFilesReply(reply, index)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Show attachments (" + _vm._s(reply.files.length) + ")")])])] : [_c('div', {
      staticClass: "columns is-multiline"
    }, [_vm._m(6, true), _vm._v(" "), _vm._l((reply.files), function(file) {
      return [_c('div', {
        staticClass: "column is-12",
        staticStyle: {
          "text-align": "center"
        }
      }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file['url'],
          "alt": "",
          "width": "90%"
        }
      })])] : [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o fa-4",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                                        " + _vm._s(file['name']) + "\n                                      ")])]], 2), _vm._v(" "), _c('div', {
        staticClass: "column is-12"
      }, [_c('article', {
        staticClass: "media"
      })])]
    })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(reply.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])])])])])])]]
  }), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 4 || _vm.occurrence.status != 3) ? _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reply.reply),
      expression: "reply.reply"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('reply')
    },
    attrs: {
      "name": "reply",
      "id": "reply",
      "placeholder": "",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.reply.reply)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reply, "reply", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reply')),
      expression: "errors.has('reply')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reply')))])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('vue-dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-queue-complete": _vm.vdSuccess,
      "vdropzone-sending": _vm.vdSendingEvent
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "is-clearfix"
  }, [(parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-info': true,
      'is-pulled-left': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.internalTip
    }
  }, [_vm._v("Internal Tip")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status != 3) ? _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.replyOccurrence
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status != 3 && parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-danger': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.replyCloseOccurrence
    }
  }, [_vm._v("Reply/Close")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status < 3 && parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-warning': true,
      'is-pulled-right': true,
      'is-loading': _vm.inProgress,
      'is-disabled': _vm.inProgress
    },
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.replyAnalysis
    }
  }, [_vm._v("Under Analysis")]) : _vm._e()])])])])]) : _vm._e()], 2)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header is-primary",
    staticStyle: {
      "box-shadow": "0 1px 0px #2366d1, 0 0 0 0px #2366d1",
      "background-color": "#2366d1"
    }
  }, [_c('p', {
    staticClass: "card-header-title is-primary",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Internal Tip")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title is-primary"
  }, [_vm._v("Reply")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ccde7a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/occurrences/OccurrenceGeneric.vue
// module id = 1059
// module chunks = 39